'use client';

import Link from 'next/link';

export default function CCPALink() {
  return (
    <Link
      href="/privacy#do-not-sell"
      className="font-body text-sm text-text-secondary hover:text-accent transition-colors duration-smooth"
    >
      Do Not Sell My Personal Information
    </Link>
  );
}
